module.exports = __webpack_public_path__ + "media/images/athletes/1825-6237d670395a4248a11438f062ced6b4.png";